var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-container",
        {
          staticClass: "px-6 py-6 full-height-container",
          attrs: { fluid: "" },
        },
        [
          _c(
            "v-row",
            { staticClass: "fill-height" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "5", lg: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "pa-6",
                      staticStyle: { height: "100%" },
                      attrs: { outlined: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-h5 font-weight-bold mb-2" },
                        [_vm._v("Generate Report")]
                      ),
                      _c(
                        "div",
                        { staticClass: "text-body-2 text--secondary mb-6" },
                        [
                          _vm._v(
                            " Select an ad group and generate a new Active Future TPR Pivot "
                          ),
                        ]
                      ),
                      _c("v-autocomplete", {
                        staticClass: "mb-4",
                        attrs: {
                          items: _vm.userAdGroups,
                          "item-text": "name",
                          "item-value": "id",
                          outlined: "",
                          "return-object": "",
                          dense: "",
                          "background-color": "input",
                          label: "Ad Group",
                        },
                        on: { change: _vm.onSelectionChange },
                        model: {
                          value: _vm.selectedAdGroup,
                          callback: function ($$v) {
                            _vm.selectedAdGroup = $$v
                          },
                          expression: "selectedAdGroup",
                        },
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "text-none font-weight-bold",
                          attrs: {
                            block: "",
                            large: "",
                            color: "primary",
                            elevation: "2",
                            disabled:
                              !_vm.selectedAdGroup ||
                              _vm.isLoading ||
                              _vm.hasActiveReports,
                            loading: _vm.isGenerating,
                          },
                          on: { click: _vm.createExport },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-file-chart-outline"),
                          ]),
                          _vm._v(" Generate Report "),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "my-6" }),
                      _vm.hasActiveReports
                        ? _c(
                            "div",
                            { staticClass: "text-caption text--secondary" },
                            [
                              _c(
                                "v-icon",
                                { attrs: { small: "", color: "orange" } },
                                [_vm._v("mdi-timer-sand")]
                              ),
                              _vm._v(
                                " A report is currently being generated. Please wait for it to complete. "
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "text-caption text--secondary" },
                            [
                              _c(
                                "v-icon",
                                { attrs: { small: "", color: "grey" } },
                                [_vm._v("mdi-information-outline")]
                              ),
                              _vm._v(
                                " Allow the system a few seconds to initialize your report request. Report generation can take up to an hour. "
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex",
                  attrs: { cols: "12", md: "7", lg: "8" },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "flex-card d-flex flex-column",
                      attrs: { outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "d-flex align-center pb-2" },
                        [
                          _c(
                            "span",
                            { staticClass: "text-h6 font-weight-bold" },
                            [_vm._v("Report Status")]
                          ),
                          _c("v-spacer"),
                          _vm.exportStatuses.length > 0
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mr-3",
                                  attrs: {
                                    small: "",
                                    outlined: "",
                                    color: "primary",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.exportStatuses.length) +
                                      " " +
                                      _vm._s(
                                        _vm.exportStatuses.length === 1
                                          ? "report"
                                          : "reports"
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                disabled: _vm.isLoading,
                                loading: _vm.isRefreshing,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.loadExportStatuses()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-refresh")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c("v-data-table", {
                        staticClass: "elevation-0 flex-table",
                        attrs: {
                          headers: _vm.exportStatusHeaders,
                          items: _vm.exportStatuses,
                          loading: _vm.isLoading,
                          "disable-sort": "",
                          dense: "",
                          height: _vm.tableHeight,
                          "fixed-header": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "loading",
                            fn: function () {
                              return [
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass: "text-center pa-8",
                                    attrs: { color: "transparent" },
                                  },
                                  [
                                    _c("v-progress-circular", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        indeterminate: "",
                                        color: "primary",
                                        size: "40",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-body-2 text--secondary",
                                      },
                                      [_vm._v("Loading reports...")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "item.adGroupName",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "font-weight-medium" },
                                  [_vm._v(" " + _vm._s(item.adGroupName) + " ")]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.status",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "font-weight-medium",
                                    attrs: {
                                      small: "",
                                      color: _vm.getStatusColor(item.status),
                                      "text-color": _vm.getStatusTextColor(
                                        item.status
                                      ),
                                    },
                                  },
                                  [
                                    item.status === "INITIALIZED"
                                      ? _c(
                                          "v-icon",
                                          { attrs: { left: "", small: "" } },
                                          [_vm._v("mdi-clock-outline")]
                                        )
                                      : item.status === "PROCESSING"
                                      ? _c(
                                          "v-icon",
                                          { attrs: { left: "", small: "" } },
                                          [_vm._v("mdi-loading mdi-spin")]
                                        )
                                      : item.status === "PROCESSED"
                                      ? _c(
                                          "v-icon",
                                          { attrs: { left: "", small: "" } },
                                          [_vm._v("mdi-check-circle")]
                                        )
                                      : item.status === "FAILED"
                                      ? _c(
                                          "v-icon",
                                          { attrs: { left: "", small: "" } },
                                          [_vm._v("mdi-alert-circle")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" " + _vm._s(item.status) + " "),
                                  ],
                                  1
                                ),
                                item.status === "FAILED" &&
                                !_vm.hasActiveReports
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "text-none ml-2",
                                        attrs: {
                                          "x-small": "",
                                          color: "error",
                                          text: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.retryExport(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { left: "", "x-small": "" },
                                          },
                                          [_vm._v("mdi-refresh")]
                                        ),
                                        _vm._v(" Retry "),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "item.timestamp",
                            fn: function ({ item }) {
                              return [
                                _c("div", { staticClass: "text-body-2" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatTimestamp(item.timestamp))
                                  ),
                                ]),
                                item.status === "INITIALIZED" ||
                                item.status === "PROCESSING"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-caption text--secondary",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getElapsedTime(item.timestamp)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "no-data",
                            fn: function () {
                              return [
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass: "text-center pa-12",
                                    attrs: { color: "transparent" },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mb-4",
                                        attrs: {
                                          size: "64",
                                          color: "grey lighten-1",
                                        },
                                      },
                                      [_vm._v(" mdi-file-document-outline ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-h6 text--secondary mb-2",
                                      },
                                      [_vm._v("No reports yet")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-body-2 text--secondary",
                                      },
                                      [
                                        _vm._v(
                                          " Generate your first report to get started "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }